module.exports = __webpack_public_path__ + "static/media/marcos.fd494fb1.png";